import './index.scss';
import React, { useState, useContext } from 'react';
import { Button, Icon, NavBar,  } from 'antd-mobile';
import { getBooleanValue } from '@/utils';
import FilterDateGroup from '@/components/filterDateGroup';
import { MultSelectGroup } from '@/components/multSelect';
import moment from 'moment';
import { MyContext } from '@/utils/contextManager';
const DateFormat = 'YYYY-MM-DD';

const Dot = (props) => (
    <div className="dot-wrapper">
          <span className="dot"></span>
          <span className="dot-label">{props.children}</span>
    </div>
);

const Filter = (props) => {

  const { value, data, onSelect = ()=>{}, handleSearch = ()=>{}, enableTime = true, multiple = false, onReset } = props;

  const [ timeObj, setTimeState ] = useState([]);

  const [ selected, setSelected ] = useState(value || {});

  const { setDrawer } = useContext(MyContext);

  const handleSelect = ({ id, child, value }) => {
    setSelect({ id, value });
    if (multiple) {
      onSelect({ id, child, value });
    } else {
      onSelect({ id, child, value: value ? value[0]: value });
    }
  }

  const getChild = (item, id, arr = []) => {
    const child = item[id].child;
    if (child) {
      arr.push(child);
      getChild(item, child, arr);
    }
    return arr;
  }

  const setSelect = ({ id, value }) => {
    const obj = {
      ...selected,
      [id]: value
    }
    const childs = getChild(data, id);
    childs.forEach(item => obj[item] = "");
    setSelected(obj);
  }

  const clearAllChild = () => {
    /* eslint-disable */
    const childKeys = Object.keys(data).filter(item => !data[item].child);
    for (const childKey of childKeys) {
      let atLast = false;
      let temp = childKey;
      while(!atLast) {
        let flag = true;
        Object.keys(data).forEach(key => {
          const item = data[key];
          if (temp === item.child) {
            data[temp].list = [];
            temp = key;
            flag = false;
          }
        });
        if (flag) {
          atLast = true;
        }
      }
    }
    /* eslint-enable */
  }

  const handleClear = () => {
    setTimeState([]);
    setSelected({});
    clearAllChild();
    handleSearch({});
    setDrawer();
    onReset && onReset();
  }

  const handleOk = () =>{
    handleSearch({
      ...getParam()
    },handleClear);
    setDrawer();
  }

  const getParam = () => {
    const obj = {};
    Object.keys(selected).filter(item => selected[item]).forEach(id => {
      obj[id] = selected[id]
    });
    if (enableTime) {
      if (enableTime === 'single') {
        obj.startTime = timeObj[0] ? `${moment(timeObj[0]).format(DateFormat)} 00:00:00`: "";
      } else {
        obj.startTime = timeObj[0] ? `${moment(timeObj[0]).format(DateFormat)} 00:00:00`: "";
        obj.endTime = timeObj[1] ? `${moment(timeObj[1]).format(DateFormat)} 23:59:59` : "";
      }
    }
    return obj;
  }
  return (
    <div className="app-layout">
     <NavBar
      mode="light"
      icon={<Icon type="left" />}
      onLeftClick={() => setDrawer(false)}
      style={getBooleanValue('IS_IMMERSE', false) ? { paddingTop: '6vw', height: '18vw' } : null}
      >
     筛选条件
      </NavBar>
      <div className="filter-wrapper">
        <div>
          { enableTime &&
            <div className="filter-tab-wrapper">
              <Dot>时间</Dot>
              <div className="filter-time-wrapper">
                  <FilterDateGroup single={enableTime === 'single'} value={timeObj} mode={'date'} format={DateFormat} onChange={setTimeState}></FilterDateGroup>
              </div>
            </div>
          }
          <MultSelectGroup multiple={multiple} onChange={(selectedObj) => handleSelect(selectedObj)} data={ data } selected={ selected }></MultSelectGroup>
          <div className="filter-tab-wrapper-last">
            <Button onClick={handleOk} style={{marginBottom: '3vw'}} type="primary">确定</Button>
            <Button onClick={handleClear}>重置</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filter;
